import {Button as MuiButton} from "@mui/material";
import MuiLoadingButton from "@mui/lab/LoadingButton";
import {cx} from "@emotion/css";
import {useMemo} from "react";

import {noop} from "~/utils/noop";

import {IButton} from "../IButton";
import {styles} from "./SecondaryButton.styles";
import {commonStyles} from "../_common/styles";

export interface BmSecondaryButtonProps
  extends Pick<IButton, "className" | "sx" | "type" | "disabled" | "size" | "onClick" | "children"> {
  loading?: boolean;
  loadingIndicator?: string;
}

export const BmSecondaryButton: React.FC<BmSecondaryButtonProps> = ({
  className,
  loading,
  loadingIndicator,
  onClick,
  size = "large",
  ...restProps
}) => {
  const commonProps = useMemo(
    () => ({
      className: cx(commonStyles.button, styles.secondaryButton, className),
      size,
      disableFocusRipple: true,
      ...restProps,
    }),
    [className, size, restProps],
  );

  return loading === undefined ? (
    <MuiButton variant="text" color="primary" onClick={onClick} {...commonProps} />
  ) : (
    <MuiLoadingButton
      variant="text"
      color="primary"
      loading={loading}
      loadingIndicator={loadingIndicator}
      onClick={loading ? noop : onClick}
      {...commonProps}
    />
  );
};
